import {
  CommonTradeAreaDetailsResponse,
  DriveTimeSectionDetails,
  DriveTimeTradeAreaDetailsRequest,
  DriveTimeTradeAreaDetailsResponse,
  DriveTimeTradeAreaMapRequest,
  FootfallSectionDetails,
  FootfallTradeAreaDetailsRequest,
  FootfallTradeAreaDetailsResponse,
  FootfallTradeAreaMapRequest,
  RadiusRingsTradeAreaDetailsRequest,
  RadiusRingsTradeAreaDetailsResponse,
  TradeAreaDateRangeResponse,
} from 'src/common-services/types/trade-area-types'
import { BaseClient } from 'src/common-services/clients/base-client'

function omit<T>(object: T, keys: Array<keyof T>): Partial<T> {
  const result: Partial<T> = {}
  for (const key in object) {
    if (keys.includes(key)) {
      continue
    }
    result[key] = object[key]
  }
  return result
}

export class TradeAreaClient extends BaseClient {
  getFootfallTradeAreaMap(request: FootfallTradeAreaMapRequest): Promise<FootfallSectionDetails[]> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-foot-traffic/map`, 'GET', { params })
  }

  getFootfallTradeAreaDetails(request: FootfallTradeAreaDetailsRequest): Promise<FootfallTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-foot-traffic`, 'GET', { params })
  }

  getFootfallNearby(request: FootfallTradeAreaDetailsRequest): Promise<CommonTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-foot-traffic/nearby`, 'GET', { params })
  }

  getDriveTimeTradeAreaMap(request: DriveTimeTradeAreaMapRequest): Promise<DriveTimeSectionDetails[]> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-drive-time/map`, 'GET', { params })
  }

  getDriveTimeTradeAreaDetails(request: DriveTimeTradeAreaDetailsRequest): Promise<DriveTimeTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-drive-time`, 'GET', { params })
  }

  getDriveTimeNearby(request: DriveTimeTradeAreaDetailsRequest): Promise<CommonTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-drive-time/nearby`, 'GET', { params })
  }

  getRadiiTradeAreaDetails(request: RadiusRingsTradeAreaDetailsRequest): Promise<RadiusRingsTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-radius-rings`, 'GET', { params })
  }

  getRadiusRingsNearby(request: RadiusRingsTradeAreaDetailsRequest): Promise<CommonTradeAreaDetailsResponse> {
    const params = omit(request, ['venueId'])
    const id = encodeURIComponent(request.venueId)
    return this.call(`/trade-area/venues/${id}/by-radius-rings/nearby`, 'GET', { params })
  }

  getTradeAreaDateRanges(): Promise<TradeAreaDateRangeResponse> {
    return this.call<TradeAreaDateRangeResponse>('/trade-area/date-ranges', 'GET')
  }
}
